import { SUBSCRIPTION_ACTIONS } from '../actions/SubscriptionActions';

const initialState = {
  // Plans
  plans: [],
  plansLoading: false,
  plansError: null,
  
  // User Subscription
  subscription: null,
  hasSubscription: false,
  subscriptionLoading: false,
  subscriptionError: null,
  
  // Status
  status: null,
  statusLoading: false,
  statusError: null,
  
  // Usage
  usage: null,
  usageLoading: false,
  usageError: null,
  
  // Payments
  payments: [],
  paymentsLoading: false,
  paymentsError: null,
  
  // Checkout
  checkoutSession: null,
  checkoutLoading: false,
  checkoutError: null,
  
  // Portal
  portalUrl: null,
  portalLoading: false,
  portalError: null,
  
  // Cancel/Reactivate
  cancelLoading: false,
  cancelError: null,
  reactivateLoading: false,
  reactivateError: null,
  
  // Admin Plan Management
  createPlanLoading: false,
  createPlanError: null,
  updatePlanLoading: false,
  updatePlanError: null,
  deletePlanLoading: false,
  deletePlanError: null
};

const SubscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Plans
    case SUBSCRIPTION_ACTIONS.FETCH_PLANS_REQUEST:
      return {
        ...state,
        plansLoading: true,
        plansError: null
      };
    case SUBSCRIPTION_ACTIONS.FETCH_PLANS_SUCCESS:
      return {
        ...state,
        plansLoading: false,
        plans: action.payload,
        plansError: null
      };
    case SUBSCRIPTION_ACTIONS.FETCH_PLANS_FAILURE:
      return {
        ...state,
        plansLoading: false,
        plansError: action.payload
      };

    // Fetch User Subscription
    case SUBSCRIPTION_ACTIONS.FETCH_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        subscriptionLoading: true,
        subscriptionError: null
      };
    case SUBSCRIPTION_ACTIONS.FETCH_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        subscriptionLoading: false,
        subscription: action.payload.subscription,
        hasSubscription: action.payload.has_subscription,
        subscriptionError: null
      };
    case SUBSCRIPTION_ACTIONS.FETCH_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        subscriptionLoading: false,
        subscriptionError: action.payload
      };

    // Check Status
    case SUBSCRIPTION_ACTIONS.CHECK_STATUS_REQUEST:
      return {
        ...state,
        statusLoading: true,
        statusError: null
      };
    case SUBSCRIPTION_ACTIONS.CHECK_STATUS_SUCCESS:
      return {
        ...state,
        statusLoading: false,
        status: action.payload,
        hasSubscription: action.payload.has_active_subscription,
        statusError: null
      };
    case SUBSCRIPTION_ACTIONS.CHECK_STATUS_FAILURE:
      return {
        ...state,
        statusLoading: false,
        statusError: action.payload
      };

    // Fetch Usage
    case SUBSCRIPTION_ACTIONS.FETCH_USAGE_REQUEST:
      return {
        ...state,
        usageLoading: true,
        usageError: null
      };
    case SUBSCRIPTION_ACTIONS.FETCH_USAGE_SUCCESS:
      return {
        ...state,
        usageLoading: false,
        usage: action.payload,
        usageError: null
      };
    case SUBSCRIPTION_ACTIONS.FETCH_USAGE_FAILURE:
      return {
        ...state,
        usageLoading: false,
        usageError: action.payload
      };

    // Fetch Payments
    case SUBSCRIPTION_ACTIONS.FETCH_PAYMENTS_REQUEST:
      return {
        ...state,
        paymentsLoading: true,
        paymentsError: null
      };
    case SUBSCRIPTION_ACTIONS.FETCH_PAYMENTS_SUCCESS:
      return {
        ...state,
        paymentsLoading: false,
        payments: action.payload,
        paymentsError: null
      };
    case SUBSCRIPTION_ACTIONS.FETCH_PAYMENTS_FAILURE:
      return {
        ...state,
        paymentsLoading: false,
        paymentsError: action.payload
      };

    // Create Checkout
    case SUBSCRIPTION_ACTIONS.CREATE_CHECKOUT_REQUEST:
      return {
        ...state,
        checkoutLoading: true,
        checkoutError: null
      };
    case SUBSCRIPTION_ACTIONS.CREATE_CHECKOUT_SUCCESS:
      return {
        ...state,
        checkoutLoading: false,
        checkoutSession: action.payload,
        checkoutError: null
      };
    case SUBSCRIPTION_ACTIONS.CREATE_CHECKOUT_FAILURE:
      return {
        ...state,
        checkoutLoading: false,
        checkoutError: action.payload
      };

    // Create Portal
    case SUBSCRIPTION_ACTIONS.CREATE_PORTAL_REQUEST:
      return {
        ...state,
        portalLoading: true,
        portalError: null
      };
    case SUBSCRIPTION_ACTIONS.CREATE_PORTAL_SUCCESS:
      return {
        ...state,
        portalLoading: false,
        portalUrl: action.payload.url,
        portalError: null
      };
    case SUBSCRIPTION_ACTIONS.CREATE_PORTAL_FAILURE:
      return {
        ...state,
        portalLoading: false,
        portalError: action.payload
      };

    // Cancel Subscription
    case SUBSCRIPTION_ACTIONS.CANCEL_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        cancelLoading: true,
        cancelError: null
      };
    case SUBSCRIPTION_ACTIONS.CANCEL_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        cancelLoading: false,
        cancelError: null
      };
    case SUBSCRIPTION_ACTIONS.CANCEL_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        cancelLoading: false,
        cancelError: action.payload
      };

    // Reactivate Subscription
    case SUBSCRIPTION_ACTIONS.REACTIVATE_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        reactivateLoading: true,
        reactivateError: null
      };
    case SUBSCRIPTION_ACTIONS.REACTIVATE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        reactivateLoading: false,
        reactivateError: null
      };
    case SUBSCRIPTION_ACTIONS.REACTIVATE_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        reactivateLoading: false,
        reactivateError: action.payload
      };

    // Admin: Create Plan
    case SUBSCRIPTION_ACTIONS.CREATE_PLAN_REQUEST:
      return {
        ...state,
        createPlanLoading: true,
        createPlanError: null
      };
    case SUBSCRIPTION_ACTIONS.CREATE_PLAN_SUCCESS:
      return {
        ...state,
        createPlanLoading: false,
        createPlanError: null
      };
    case SUBSCRIPTION_ACTIONS.CREATE_PLAN_FAILURE:
      return {
        ...state,
        createPlanLoading: false,
        createPlanError: action.payload
      };

    // Admin: Update Plan
    case SUBSCRIPTION_ACTIONS.UPDATE_PLAN_REQUEST:
      return {
        ...state,
        updatePlanLoading: true,
        updatePlanError: null
      };
    case SUBSCRIPTION_ACTIONS.UPDATE_PLAN_SUCCESS:
      return {
        ...state,
        updatePlanLoading: false,
        updatePlanError: null
      };
    case SUBSCRIPTION_ACTIONS.UPDATE_PLAN_FAILURE:
      return {
        ...state,
        updatePlanLoading: false,
        updatePlanError: action.payload
      };

    // Admin: Delete Plan
    case SUBSCRIPTION_ACTIONS.DELETE_PLAN_REQUEST:
      return {
        ...state,
        deletePlanLoading: true,
        deletePlanError: null
      };
    case SUBSCRIPTION_ACTIONS.DELETE_PLAN_SUCCESS:
      return {
        ...state,
        deletePlanLoading: false,
        deletePlanError: null
      };
    case SUBSCRIPTION_ACTIONS.DELETE_PLAN_FAILURE:
      return {
        ...state,
        deletePlanLoading: false,
        deletePlanError: action.payload
      };

    // Clear Error
    case SUBSCRIPTION_ACTIONS.CLEAR_SUBSCRIPTION_ERROR:
      return {
        ...state,
        plansError: null,
        subscriptionError: null,
        statusError: null,
        usageError: null,
        paymentsError: null,
        checkoutError: null,
        portalError: null,
        cancelError: null,
        reactivateError: null,
        createPlanError: null,
        updatePlanError: null,
        deletePlanError: null
      };

    default:
      return state;
  }
};

export default SubscriptionReducer;
